const INITIAL_STATE = {
    id: "",
    first_name: "",
    last_name: "",
    identification_number: "",
    email: "",
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type){
        case "SET_USER_DATA":
            return {...state, ...action.payload};
        case "UNSET_USER_DATA":
            return INITIAL_STATE;
        default:
              return state;
    }
}
